import { StyleRules } from '@material-ui/core/styles';
import { ButtonClassKey } from '@material-ui/core/Button';

import { core as theme } from '../styles/core';

export const MuiButton: Partial<StyleRules<ButtonClassKey>> = {
  root: {
    padding: '11px 16px',
  },
  sizeLarge: {
    fontSize: theme.typography.button.fontSize,
  },
  sizeSmall: {
    fontSize: theme.typography.button.fontSize,
  },
  contained: {
    backgroundColor: theme.palette.grey.A200,
    color: theme.palette.grey[600],
    padding: '11px 16px',
    '&:hover': {
      backgroundColor: theme.palette.grey.A400,
    },
    '&:disabled': {
      backgroundColor: theme.palette.grey[300],
      color: theme.palette.grey[50],
    },
  },
  containedSizeSmall: {
    padding: '9px 16px',
  },
  containedSizeLarge: {
    padding: '13px 16px',
  },
  containedPrimary: {
    color: theme.palette.grey[50],
  },
  text: {
    color: theme.palette.grey[600],
    padding: '11px 16px',
    '&:hover': {
      backgroundColor: theme.palette.grey.A400,
    },
    '&:disabled': {
      color: theme.palette.grey[300],
    },
  },
  textSizeSmall: {
    padding: '9px 16px',
  },
  textSizeLarge: {
    padding: '13px 16px',
  },
  textPrimary: {
    color: theme.palette.grey[600],
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.lightest,
    },
  },
  textSecondary: {
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.secondary.lightest,
    },
  },
  outlined: {
    color: theme.palette.grey[600],
    padding: '10px 15px',
    border: `1px solid ${theme.palette.grey[600]}`,
    '&:disabled': {
      color: theme.palette.grey[300],
      border: `1px solid ${theme.palette.grey[300]}`,
    },
  },
  outlinedSizeLarge: {
    padding: '12px 15px',
  },
  outlinedSizeSmall: {
    padding: '8px 15px',
  },
  outlinedPrimary: {
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      backgroundColor: theme.palette.primary.lightest,
    },
  },
  outlinedSecondary: {
    border: `1px solid ${theme.palette.secondary.main}`,
    '&:hover': {
      backgroundColor: theme.palette.secondary.lightest,
    },
  },
  iconSizeSmall: {
    '& > *:first-child': {
      fontSize: '16px',
    },
  },
  startIcon: {
    marginRight: theme.spacing(0.5),
  },
  endIcon: {
    marginLeft: theme.spacing(0.5),
  },
};
